import { Tooltip } from 'antd';
import cx from 'classnames';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import styles from './tooltipCell.module.scss';

interface TooltipCellProps {
  value: string;
}

export const TooltipCell: FC<TooltipCellProps> = ({ value }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const tooltipContent = useMemo(
    () => <div className={cx(styles['tooltipContent'])}>{value}</div>,
    [value]
  );

  useEffect(() => {
    const element = contentRef.current;
    if (!element) return;

    const checkTruncation = () => {
      setIsTruncated(element.scrollHeight > element.clientHeight);
    };

    const resizeObserver = new ResizeObserver(checkTruncation);
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [value]);

  if (!value) return;

  return (
    <Tooltip
      overlayClassName={cx(styles['tooltip'])}
      title={isTruncated ? tooltipContent : null}
      placement='bottomLeft'
      destroyTooltipOnHide
    >
      <div
        ref={contentRef}
        className={cx(styles['tooltipCell'])}
        data-testid='business-document-tooltip-cell'
      >
        {value}
      </div>
    </Tooltip>
  );
};
